import pathToTitleLabelMap from '../../../config/pathToTitleMap.json';

const FALLBACK_TITLE = 'BBC';

export default function getTitle(currentPath, translations) {
    const currentLabel = pathToTitleLabelMap[currentPath.toLowerCase()];

    if (!currentLabel) {
        return FALLBACK_TITLE;
    }

    return translations[currentLabel] || FALLBACK_TITLE;
}
